module.exports = __webpack_public_path__ + "img/odisys.97b6d255.png";